
export function isNullOrUndefined<T>(value: T | null | undefined): value is null | undefined {
  // eslint-disable-next-line no-undefined
  return value === null || value === undefined;
}

export function isNotNullOrUndefined<T>(value: T | null | undefined): value is T {
  return !isNullOrUndefined(value);
}

export function isNullOrUndefinedOrEmpty(str: string | null | undefined): str is null | undefined | '' {
  if(isNullOrUndefined(str)) {
    return true;
  }

  return str.length <= 0;
}

export function isNotNullOrUndefinedOrEmpty(str: string | null | undefined): str is string {
  return !isNullOrUndefinedOrEmpty(str);
}
